<div class="timeline">
  <p *ngIf="subTitle" class="timeline__sub-title body-sm">
    {{ subTitle }}
  </p>
  <app-timeline-list
    *ngIf="hasCollection"
    class="timeline__collection"
    [collection]="collection"
  ></app-timeline-list>
</div>
